$(document).ready(function() {
    if($('.customer_reviews_scroller').length > 0 && $('.customer-reviews').length > 0) {
        $('.customer_reviews_scroller').addClass('active');
    }
});


//TOGGLE ANIMATION CLASS
$.fn.extend({
    animateCss: function (animationName, callback) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        this.addClass('animated ' + animationName).one(animationEnd, function() {
            $(this).removeClass('animated ' + animationName);
            if (callback) {
                callback();
            }
        });
        return this;
    }
});

//FUNCTION TO SELECT END OF TRANSITION

var whichTransitionEvent = function () {
    var t;
    var el = document.createElement('fakeelement');
    var transitions = {
        'transition': 'transitionend',
        'OTransition': 'oTransitionEnd',
        'MozTransition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd'
    };

    for (t in transitions) {
        if (el.style[t] !== undefined) {
            return transitions[t];
        }
    }
};

// ABOUT PAGE GALLERY SWIPERS

function isInViewport(elem) {
    var top_of_element = elem.offset().top;
    var bottom_of_element = elem.offset().top + elem.outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();

    return ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element));
}

if ($('.swiper-container.about-gallery').length > 0) {
    $('.swiper-container.about-gallery').each(function(index, element){

        var $this = $(this);
        var prevControl = $this.find('.navigation .prev');
        var nextControl = $this.find('.navigation .next');

        $this.addClass("instance-" + index);
        $this.find(".swiper-button-prev").addClass("btn-prev-" + index);
        $this.find(".swiper-button-next").addClass("btn-next-" + index);

        var swiper = new Swiper(".instance-" + index, {
            speed: 0,
            slidesPerView: 1,
            allowTouchMove: false,
            effect: 'fade',
            autoHeight: true,
            loop: true,
            fadeEffect: {
                crossFade: true
            },
            lazy: {
                loadPrevNext: true,
                preloadImages: false,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true,
            },
            on: {
                init: function() {
                    if ($(this)[0].isEnd) {
                        nextControl.addClass('inactive');
                    }
                    if ($(this)[0].isBeginning) {
                        prevControl.addClass('inactive');
                    }
                }
            }
        });

        $('.navigation .next.btn-next-' + index).on('click', function() {
            var activeSwiper = $(swiper)[0]['$el'][0];

            $(activeSwiper).addClass('custom-transition');

            setTimeout(function() {
                swiper.slideNext();

                prevControl.removeClass('inactive');
                nextControl.removeClass('inactive');

                if (swiper.isEnd) {
                    nextControl.addClass('inactive');
                }
                if (swiper.isBeginning) {
                    prevControl.addClass('inactive');
                }
            }, 300);

            setTimeout(function() {
                $(activeSwiper).removeClass('custom-transition');
            }, 600);

        });

        $('.navigation .prev.btn-prev-' + index).on('click', function() {
            var activeSwiper = $(swiper)[0]['$el'][0];

            $(activeSwiper).addClass('custom-transition');

            setTimeout(function() {
                swiper.slidePrev();

                prevControl.removeClass('inactive');
                nextControl.removeClass('inactive');

                if (swiper.isEnd) {
                    nextControl.addClass('inactive');
                }
                if (swiper.isBeginning) {
                    prevControl.addClass('inactive');
                }
            }, 300);

            setTimeout(function() {
                $(activeSwiper).removeClass('custom-transition');
            }, 600);

        });

        setInterval(function() {
            var activeSwiper = $(swiper)[0]['$el'][0];

            $(activeSwiper).addClass('custom-transition');

            setTimeout(function() {
                swiper.slideNext();

                prevControl.removeClass('inactive');
                nextControl.removeClass('inactive');

                if (swiper.isEnd) {
                    nextControl.addClass('inactive');
                }
                if (swiper.isBeginning) {
                    prevControl.addClass('inactive');
                }
            }, 300);

            setTimeout(function() {
                $(activeSwiper).removeClass('custom-transition');
            }, 600);
        }, 16000)

    });
}


//
// customer reviews slider
//

var customerReviewsSlider = $('.customer-reviews-slider');

if(customerReviewsSlider.length) {

    var nextArrow = $('.customer-reviews .customer-reviews-slider--next');
    var prevArrow = $('.customer-reviews .customer-reviews-slider--prev');

    var customer_reviews_slider = new Swiper('.customer-reviews-slider.swiper-container', {
        slidesPerView: 1,
        autoHeight: true,
        touchRatio: 1,
        navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
        },
        renderCustom: function (customer_reviews_slider, current, total) {
            console.log(current + ' of ' + total);
        },
    });

    customer_reviews_slider.on('slideChange', function () {
        console.log(this.activeIndex);
    });


    if($('.customer_reviews_scroller--img').length > 0) {
        var imgLen = $('.customer_reviews_scroller--img').length;
        var firstnum = 0;
        var secondnum = 0;
        setInterval(function(){
            if(firstnum < imgLen) {
                $('.customer_reviews_scroller--img').not($('.customer_reviews_scroller--img').eq(firstnum)).removeClass('active');
                $('.customer_reviews_scroller--img').eq(firstnum).addClass('active');
                firstnum++;
            } else {
                firstnum = 0;
                $('.customer_reviews_scroller--img').not($('.customer_reviews_scroller--img').eq(firstnum)).removeClass('active');
                $('.customer_reviews_scroller--img').eq(firstnum).addClass('active');
                firstnum++;
            }
        }, 5000);

        $('.customer_reviews_scroller').on('click', function (e) {
            var thisEl = $(this);
            var thisImg = thisEl.find('.customer_reviews_scroller--img.active');
            var thisImgNum = thisImg.attr('data-img-num');
            customer_reviews_slider.slideTo(thisImgNum);
            $("body,html").animate(
                {
                    scrollTop: $(".customer-reviews").offset().top
                },
                800 //speed
            );
        });

    }



}


// $(document).ready(function() {
//     var sec = document.getElementById("customer-reviews");
//     var pos = sec.getBoundingClientRect();
//     var height1 = pos.height * -1;
//     console.log(pos.top);
//     console.log(height1);
//     if (pos.top < 1 && pos.top > height1) {
//
//         $('.customer_reviews_scroller').removeClass('active');
//     }
//     else if(pos.top < height1 || pos.top > 1) {
//         $('.customer_reviews_scroller').addClass('active');
//     }
// });
// $(window).scroll(function() {
//     var sec = document.getElementById("customer-reviews");
//     var pos = sec.getBoundingClientRect();
//     var height1 = pos.height * -1;
//     console.log(pos.top);
//     console.log(height1);
//     console.log(pos.top);
//     console.log(pos.bottom);
//     if (pos.top < 1 && pos.top > height1) {
//
//         $('.customer_reviews_scroller').removeClass('active');
//     }
//     else if(pos.top < height1 || pos.top > 1) {
//         $('.customer_reviews_scroller').addClass('active');
//     }
// });



// SINGLE FLAT SWIPER
if ($('.swiper-container.flat-gallery').length > 0) {
    var swiperFlatGallery = new Swiper('.flat-gallery', {
        speed: 0,
        slidesPerView: 1,
        allowTouchMove: false,
        effect: 'fade',
        autoHeight: true,
        fadeEffect: {
            crossFade: true
        }
    });

    $('.plans-header .plan-link').on('click', function() {

        if (!$(this).hasClass('active')) {
            var swiper = $(swiperFlatGallery)[0]['$el'][0];

            $(this).siblings().removeClass('active');
            $(this).addClass('active');

            var slideIndex = $(this).attr('data-slide');

            $(swiper).addClass('custom-transition');

            setTimeout(function() {
                swiperFlatGallery.slideTo(slideIndex - 1);
            }, 350);

            setTimeout(function() {
                $(swiper).removeClass('custom-transition');
            }, 600);

        }

    });
}


// FLOOR SELECTION SWIPER
if ($('.swiper-container.building-swiper').length > 0) {

    var selectedBuilding = $('.floor-flats .building-selection .item.active').data('building-target'),
        selectedFloor = $('.floor-flats .plans .plan-link.active').data('floor-target');

    // var floorSwiperK1 = new Swiper('.building-swiper#k1', {
    //     speed: 600,
    //     slidesPerView: 1,
    //     allowTouchMove: false,
    //     effect: 'fade',
    //     fadeEffect: {
    //         crossFade: true
    //     },
    //     observer: true,
    //     observeParents: true,
    // });
    // var floorSwiperK2 = new Swiper('.building-swiper#k2', {
    //     speed: 600,
    //     slidesPerView: 1,
    //     allowTouchMove: false,
    //     effect: 'fade',
    //     fadeEffect: {
    //         crossFade: true
    //     },
    //     observer: true,
    //     observeParents: true,
    // });
    // var floorSwiperK3 = new Swiper('.building-swiper#k3', {
    //     speed: 600,
    //     slidesPerView: 1,
    //     allowTouchMove: false,
    //     effect: 'fade',
    //     fadeEffect: {
    //         crossFade: true
    //     },
    //     observer: true,
    //     observeParents: true,
    // });


    var floorSwiperK1 = undefined;
    var floorSwiperK2 = undefined;
    var floorSwiperK3 = undefined;
    var sw = $(window).width();
    function initSwiper() {
        var screenWidth = $(window).width();
        if(screenWidth > 767 && floorSwiperK1 == undefined) {
            floorSwiperK1 = new Swiper('.building-swiper#k1', {
                speed: 600,
                slidesPerView: 1,
                allowTouchMove: false,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                observer: true,
                observeParents: true,
            });
            floorSwiperK2 = new Swiper('.building-swiper#k2', {
                speed: 600,
                slidesPerView: 1,
                allowTouchMove: false,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                observer: true,
                observeParents: true,
            });
            if($('.building-swiper#k3').length > 0) {
                floorSwiperK3 = new Swiper('.building-swiper#k3', {
                    speed: 600,
                    slidesPerView: 1,
                    allowTouchMove: false,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    observer: true,
                    observeParents: true,
                });
            }

        } else if (screenWidth <= 767 && floorSwiperK1 != undefined) {
            floorSwiperK1.detachEvents();
            floorSwiperK2.detachEvents();
            floorSwiperK1.destroy();
            floorSwiperK2.destroy();
            if($('.building-swiper#k3').length > 0) {
                floorSwiperK3.destroy();
            }
            floorSwiperK1 = undefined;
            floorSwiperK2 = undefined;
            if($('.building-swiper#k3').length > 0) {
                floorSwiperK3 = undefined;
            }
            $('.building-swiper .swiper-wrapper').removeAttr('style');
            $('.building-swiper .swiper-slide').removeAttr('style');
        }
    }

    //Swiper plugin initialization
    initSwiper();

    //Swiper plugin initialization on window resize
    $(window).on('resize', function(){
        initSwiper();
        chageFloor();
    });

    chageFloor();


    function chageFloor() {
        if(sw > 767) {
            if (selectedBuilding == 1) {
                floorSwiperK1.slideTo(selectedFloor - 1);

                $('.building-swiper.active .building-block').removeClass('active');
                $('.building-swiper.active .building-block').removeClass('open');
                $('.building-swiper.active .building-block[data-floor-target='+ selectedFloor +']').addClass('active');
            } else if (selectedBuilding == 2) {
                floorSwiperK2.slideTo(selectedFloor - 1);

                $('.building-swiper.active .building-block').removeClass('active');
                $('.building-swiper.active .building-block').removeClass('open');
                $('.building-swiper.active .building-block[data-floor-target='+ selectedFloor +']').addClass('active');
            } else if (selectedBuilding == 3) {
                floorSwiperK3.slideTo(selectedFloor - 1);

                $('.building-swiper.active .building-block').removeClass('active');
                $('.building-swiper.active .building-block').removeClass('open');
                $('.building-swiper.active .building-block[data-floor-target='+ selectedFloor +']').addClass('active');
            }

            // Floor selection
            $(document).on('click', '.floor-flats .plans .plan-link', function () {

                $(this).siblings().removeClass('active');
                $(this).addClass('active');

                selectedFloor = $(this).data('floor-target');

                console.log(selectedFloor);

                if ($(this).closest('.building-swiper').is('#k1')) {
                    floorSwiperK1.slideTo(selectedFloor - 1);

                    $('.building-swiper.active .building-block').removeClass('active');
                    $('.building-swiper.active .building-block').removeClass('open');
                    $('.building-swiper.active .building-block[data-floor-target='+ selectedFloor +']').addClass('active');
                } else if ($(this).closest('.building-swiper').is('#k2')) {
                    floorSwiperK2.slideTo(selectedFloor - 1);

                    $('.building-swiper.active .building-block').removeClass('active');
                    $('.building-swiper.active .building-block').removeClass('open');
                    $('.building-swiper.active .building-block[data-floor-target='+ selectedFloor +']').addClass('active');
                } else if ($(this).closest('.building-swiper').is('#k3')) {
                    floorSwiperK3.slideTo(selectedFloor - 1);

                    $('.building-swiper.active .building-block').removeClass('active');
                    $('.building-swiper.active .building-block').removeClass('open');
                    $('.building-swiper.active .building-block[data-floor-target='+ selectedFloor +']').addClass('active');
                }

                updateFloorSelectionUrl();

            });
        } else if(sw <= 767) {
            $(document).on('click', '.building-header', function(){
                var thisClick = $(this);
                var thisBlock = thisClick.parents('.building-block');
                var thisPlan = thisBlock.find('.building-body');

                if(!(thisBlock.hasClass('active'))|| !(thisBlock.hasClass('open'))) {
                    $('.building-swiper.active .building-block').not(thisBlock).removeClass('active');
                    $('.building-swiper.active .building-block').not(thisBlock).removeClass('open');
                    thisBlock.addClass('open');
                    $('.building-swiper.active .building-body').not(thisPlan).slideUp(300, function () {
                        thisPlan.slideDown(300);
                    });
                }
            });
        }
    }
}


// PARKING SELECTION SWIPER
if ($('.swiper-container.parking-swiper').length > 0) {
    var selectedParkingPlan = $('.parking-plans .plan-link.active').data('floor-target');
    var parkingSwiper = undefined;
    var window_width = $(window).width();
    function initParkingSwiper() {
        var screenWidth = $(window).width();
        if (screenWidth > 767 && parkingSwiper == undefined) {
            parkingSwiper = new Swiper('.parking-swiper', {
                speed: 600,
                slidesPerView: 1,
                allowTouchMove: false,
                effect: 'fade',
                autoHeight: true, //enable auto height
                fadeEffect: {
                    crossFade: true
                },
                observer: true,
                observeParents: true,
            });
        } else if (screenWidth <= 767 && parkingSwiper != undefined) {
            parkingSwiper.detachEvents();
            parkingSwiper.destroy();
            parkingSwiper = undefined;
            $('.parking-swiper .swiper-wrapper').removeAttr('style');
            $('.parking-swiper .swiper-slide').removeAttr('style');
        }
    }
    //Swiper plugin initialization
    initParkingSwiper();

    //Swiper plugin initialization on window resize
    $(window).on('resize', function(){
        initParkingSwiper();
        chageParking();
    });


    chageParking();


    function chageParking() {
        if(window_width > 767) {

            // Floor selection
            $(document).on('click', '.parking-plans .plan-link', function () {

                $(this).siblings().removeClass('active');
                $(this).addClass('active');

                selectedParkingPlan = $(this).data('floor-target');
                //
                // console.log(selectedFloor);

                parkingSwiper.slideTo(selectedParkingPlan - 1);

                $('.parking-swiper.active .parking-block').removeClass('active');
                $('.parking-swiper.active .parking-block').removeClass('open');
                $('.parking-swiper.active .parking-block[data-floor-target='+ selectedParkingPlan +']').addClass('active');
                // updateFloorSelectionUrl();

            });
        } else if(window_width <= 767) {
            $(document).on('click', '.parking-header', function(){
                var thisClick = $(this);
                var thisBlock = thisClick.parents('.parking-block');
                var thisPlan = thisBlock.find('.parking-body');
                if(!thisBlock.hasClass('stop')) {
                    thisBlock.addClass('stop');
                    if(!(thisBlock.hasClass('open'))) {
                        thisPlan.slideDown(300);
                        thisBlock.addClass('open');
                    } else {
                        thisPlan.slideUp(300);
                        thisBlock.removeClass('open');
                    }
                    setTimeout(function(){
                        thisBlock.removeClass('stop');
                    }, 800);
                }

            });
        }
    }

}


// NEWS PAGE SWIPER

if ($('.swiper-container.news-swiper').length > 0) {
    var swiperNews = new Swiper('.swiper-container.news-swiper', {
        speed: 500,
        slidesPerView: 2.5,
        loop: false,
        spaceBetween: 40,
        rebuildOnUpdate: true,
        breakpoints: {
            1020: {
                slidesPerView: 1.8
            },
            820: {
                slidesPerView: 1.3
            },
            500: {
                slidesPerView: 1,
                spaceBetween: 20,
                autoHeight: true
            }
        },
        lazy: {
            loadPrevNext: true,
            preloadImages: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: true,
        }
    });

    $('.news-section .navigation .next').on('click', function() {
        swiperNews.slideNext();
    });

    $('.news-section .navigation .prev').on('click', function() {
        swiperNews.slidePrev();
    });
}


// CONTACTS OFFICE SWIPER

if ($('.swiper-container.contacts-swiper').length > 0) {
    var swiperContacts= new Swiper('.swiper-container.contacts-swiper', {
        speed: 500,
        slidesPerView: 1,
        loop: true,
        breakpointsInverse: true,
        rebuildOnUpdate: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        lazy: {
            loadPrevNext: true,
            preloadImages: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: true,
        }
    });

    $('.swiper-container.contacts-swiper .navigation .next').on('click', function() {
        swiperContacts.slideNext();
    });

    $('.swiper-container.contacts-swiper .navigation .prev').on('click', function() {
        swiperContacts.slidePrev();
    });
}

// GALLERY PAGE SWIPERS

if ($('.swiper-container.gallery-swiper-first').length > 0) {

    if (window.innerWidth >= 1260) {
        var swiperGalleryFirst = new Swiper('.swiper-container.gallery-swiper-first', {
            speed: 500,
            slidesPerView: 1,
            loop: true,
            breakpointsInverse: true,
            rebuildOnUpdate: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            lazy: {
                loadPrevNext: true,
                preloadImages: false,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true,
            }
        });
    }
    else {
        var swiperGalleryFirst = new Swiper('.swiper-container.gallery-swiper-first', {
            speed: 500,
            slidesPerView: 1,
            loop: true,
            breakpointsInverse: true,
            rebuildOnUpdate: true,
            lazy: {
                loadPrevNext: true,
                preloadImages: false,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true,
            },
        });
    }

    $('.swiper-container.gallery-swiper-first .navigation .next').on('click', function() {
        swiperGalleryFirst.slideNext();
    });

    $('.swiper-container.gallery-swiper-first .navigation .prev').on('click', function() {
        swiperGalleryFirst.slidePrev();
    });

}

if ($('.swiper-container.gallery-swiper-second').length > 0) {

    if (window.innerWidth >= 1260) {
        var swiperGallerySecond = new Swiper('.swiper-container.gallery-swiper-second', {
            speed: 500,
            slidesPerView: 1,
            loop: true,
            breakpointsInverse: true,
            rebuildOnUpdate: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            lazy: {
                loadPrevNext: true,
                preloadImages: false,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true,
            }
        });
    }
    else {
        var swiperGallerySecond = new Swiper('.swiper-container.gallery-swiper-second', {
            speed: 500,
            slidesPerView: 1,
            loop: true,
            breakpointsInverse: true,
            rebuildOnUpdate: true,
            lazy: {
                loadPrevNext: true,
                preloadImages: false,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true,
            },
        });
    }

    $('.swiper-container.gallery-swiper-second .navigation .next').on('click', function() {
        swiperGallerySecond.slideNext();
    });

    $('.swiper-container.gallery-swiper-second .navigation .prev').on('click', function() {
        swiperGallerySecond.slidePrev();
    });

}

if ($('.swiper-container.gallery-swiper-third').length > 0) {

    if (window.innerWidth >= 1260) {
        var swiperGalleryThird = new Swiper('.swiper-container.gallery-swiper-third', {
            speed: 500,
            slidesPerView: 1,
            loop: true,
            breakpointsInverse: true,
            rebuildOnUpdate: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            lazy: {
                loadPrevNext: true,
                preloadImages: false,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true,
            }
        });
    }
    else {
        var swiperGalleryThird = new Swiper('.swiper-container.gallery-swiper-third', {
            speed: 500,
            slidesPerView: 1,
            loop: true,
            breakpointsInverse: true,
            rebuildOnUpdate: true,
            lazy: {
                loadPrevNext: true,
                preloadImages: false,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true,
            },
        });
    }

    $('.swiper-container.gallery-swiper-third .navigation .next').on('click', function() {
        swiperGalleryThird.slideNext();
    });

    $('.swiper-container.gallery-swiper-third .navigation .prev').on('click', function() {
        swiperGalleryThird.slidePrev();
    });

}


//SET MAPS LEGEND SELECTOR HEIGHT

var setMapSelectorHeight = function () {
  var selector = $('.locations-gmaps .legend-wrap');

  if(selector.length > 0 && window.innerWidth < 992) {
      selector.siblings('.map').css('margin-top', selector.outerHeight());
  }
};

//HANDLE MODAL SLIDER

var modalSlider = $('.modal .swiper-container');

if( modalSlider.length ) {
    var swiperModal = new Swiper('.modal .swiper-container', {
        speed: 500,
        loop: false,
        navigation: {
            nextEl: '.modal .swiper-container .swiper-button-next',
            prevEl: '.modal .swiper-container .swiper-button-prev',
        },
        simulateTouch: false
    });
}

var progressSlider = $('.progress-slider');

if( progressSlider.length ) {
    new Swiper('.progress-slider', {
        speed: 500,
        slidesPerView: 1,
        loop: true,
        breakpointsInverse: true,
        rebuildOnUpdate: true,
        navigation: {
            nextEl: '.progress-slider-wrap .swiper-button-next',
            prevEl: '.progress-slider-wrap .swiper-button-prev',
        },
        autoplay: {
            delay: 2000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        lazy: {
            loadPrevNext: true,
            preloadImages: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: true,
        }
    });
}

var progressItemsSlider = $('.progress-vertical');

if( progressItemsSlider.length ) {
    new Swiper('.progress-vertical', {
        direction: 'vertical',
        slidesPerView: 2,
        loop: false,
        breakpointsInverse: true,
        rebuildOnUpdate: true,
        autoHeight: true,
        navigation: {
            nextEl: '.progress-vertical .swiper-button-next',
            prevEl: '.progress-vertical .swiper-button-prev',
        },
        breakpoints: {
            991: {
                slidesPerView: 3
            }
        },
        onSlideChangeStart: function (s) {
            console.log('yo yo');
            console.log(s);
            var activeSlideHeight = s.slides.eq(s.activeIndex).height();
            s.container.css({height: activeSlideHeight+'px'
            });
        }
    });
}


//OPEN MODAL

var openModal = function () {
    var modal = $('.modal');

    if(modal.length > 0 && !sessionStorage.getItem('modal')) {

        setTimeout(function () {

            $('body').addClass('fixed modal-open');

            modal.removeClass('hide').one(transitionEvent, function () {
                modal.find('.modal-wrap').removeClass('hide');
            })

        }, 10000);

        sessionStorage.setItem('modal', true);
    }
};

//CLOSE MODAL

var closeModal = function() {
    var modal = $('.modal');

    if(modal.length > 0 && !(modal.hasClass('hide'))) {
        modal.find('.modal-wrap').addClass('hide').one(transitionEvent, function () {
            modal.addClass('hide');
        })
    }

    $('body').removeClass('fixed modal-open');
};

//CLOSE HERO

var closeHero = function () {

    //console.log('Close Hero Function');

    if(!$('.modal').length > 0) {
        $('body').removeClass('fixed');
    }

    $('.hero').addClass('hide');
};

//RANDOM VARS
var isMS = navigator.userAgent.indexOf('MSIE') != -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || navigator.userAgent.indexOf('Edge') != -1,
    isIE = navigator.userAgent.indexOf('MSIE') != -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./),
    isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
    isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1,
    transitionEvent = whichTransitionEvent(),
    a = 0,
    lastY = 0;
